<template>
  <div id="app"><index :ism="ism"></index></div>
</template>

<script>
import index from "./view/index.vue";

export default {
  name: "App",
  components: {
    index,
  },
  data() {
    return {
      ism: "",
    };
  },
  mounted() {
    if (this._isMobile()) {
      this.ism = "M";
    } else {
      this.ism = "PC";
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
}
#app {
  width: 100%;
  height: auto;
  background-position: center center;
  background-repeat: no-repeat;
  background-position: 0vh 0vh;
  background: url("./assets/img/pc/bg3.jpg");
  background-size: 100%;
}
textarea {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
em {
  font-style: normal;
}

input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
</style>
